import styled from "styled-components";

import { GroupedPill, PrimaryPill } from "../../Pill";

const StyledGroupPillWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 100%;
`;

type SelectedHiddenCountIndicatorProps = {
  showPill: boolean;
  labels: string[];
};

export const SelectedHiddenCountIndicator = ({
  showPill = false,
  labels = [],
}: SelectedHiddenCountIndicatorProps) => (
  <StyledGroupPillWrapper>
    {showPill && (
      <GroupedPill
        testId="SelectedHiddenCount"
        openOnHover
        horizontalPosition="left"
      >
        {labels.map((label: string, index: number) => (
          <PrimaryPill key={`${label}-${index}`} variant="INACTIVE">
            {label}
          </PrimaryPill>
        ))}
      </GroupedPill>
    )}
  </StyledGroupPillWrapper>
);
